module.exports = __webpack_public_path__ + "img/album_art.9a03824c.png";